// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_hIc","cls2":"SearchUpsell-cls2_SQ4 SearchUpsell-cls1_hIc"};